// ThankYou.js
import React from 'react';
import { Container } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa'; // ✅ Font Awesome icon
import './thank-you.css'; // 👈 Add custom CSS file for extra styling

const ThankYou = () => {
  return (
    <div className="thank-you-wrapper">
      <Container className="text-center thank-you-container">
        <FaCheckCircle className="thank-you-icon" />
        <h2 className="thank-you-title">Thank You!</h2>
        <p className="thank-you-message">Your application has been submitted successfully.</p>
      </Container>
    </div>
  );
};

export default ThankYou;
